import { css } from "@emotion/react";

import { COLORS, HELPERS, VARS } from "styles-js";

export const fonts = css`
  @import url("https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap");
`;

export const reset = css`
  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
  }

  input[type="text"],
  input[type="email"],
  input[type="search"],
  input[type="password"] {
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  /*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */

  html {
    height: 100%;
    line-height: 1.15;
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    height: 100%;
    margin: 0;
    &.page-home {
      ${HELPERS.media.smallerThan.md} {
        margin-bottom: 50px;
      }
    }
    &.dimmed {
      overflow: hidden;
    }
  }

  /* body::-webkit-scrollbar { width: 0 !important; } */

  article,
  aside,
  footer,
  header,
  nav,
  section {
    display: block;
  }

  h1 {
    font-size: 2em;
    margin: 0.67em 0;
  }

  figcaption,
  figure,
  main {
    display: block;
  }

  figure {
    margin: 1em 40px;
  }

  hr {
    box-sizing: content-box;
    height: 0;
    overflow: visible;
  }

  pre {
    font-family: monospace, monospace;
    font-size: 1em;
  }

  a {
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline;
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }

  b,
  strong {
    font-weight: inherit;
  }

  b,
  strong {
    font-weight: bolder;
  }

  code,
  kbd,
  samp {
    font-family: monospace, monospace;
    font-size: 1em;
  }

  dfn {
    font-style: italic;
  }

  mark {
    background-color: #ff0;
    color: #000;
  }

  small {
    font-size: 80%;
  }

  sub,
  sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  audio,
  video {
    display: inline-block;
  }

  audio:not([controls]) {
    display: none;
    height: 0;
  }

  img {
    border-style: none;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-size: 100%;
    line-height: 1.15;
    margin: 0;
    font-family: ${VARS.base.fontFamily};
  }

  button,
  input {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button,
// html [type="button"],
[type="reset"],
[type="submit"] {
    -webkit-appearance: button;
  }

  button::-moz-focus-inner,
// [type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  button:-moz-focusring,
// [type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  legend {
    box-sizing: border-box;
    color: inherit;
    display: table;
    max-width: 100%;
    padding: 0;
    white-space: normal;
  }

  progress {
    display: inline-block;
    vertical-align: baseline;
  }

  textarea {
    overflow: auto;
  }

  [type="checkbox"],
  [type="radio"] {
    box-sizing: border-box;
    padding: 0;
  }

  [type="number"]::-webkit-inner-spin-button,
  [type="number"]::-webkit-outer-spin-button {
    height: auto;
  }

  [type="search"] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }

  [type="search"]::-webkit-search-cancel-button,
  [type="search"]::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }

  details,
  menu {
    display: block;
  }

  summary {
    display: list-item;
  }

  canvas {
    display: inline-block;
  }

  template {
    display: none;
  }

  [hidden] {
    display: none;
  }
`;

export const site = css`
  html,
  body {
    min-height: 100%;
  }

  html {
    font-size: 14px;
  }

  body {
    margin: 0px;
    padding: 0px;
    min-width: 320px;
    background: #ffffff;
    font-size: 14px;
    line-height: 1.4285em;
    color: rgba(0, 0, 0, 0.85);
    font-weight: ${VARS.font.regular};
    /* font-smoothing: antialiased; */
  }
  body.overflow-hidden {
    overflow: hidden;
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    line-height: 1.28571429em;
    margin: calc(2rem - 0.14285714em) 0em 1rem;
    padding: 0em;
  }

  h1 {
    min-height: 1rem;
    font-size: 2.28571429rem;
  }

  h2 {
    font-size: 2rem;
  }

  h3 {
    font-size: 1.78571429rem;
  }

  h4 {
    font-size: 1.5rem;
  }

  h5 {
    font-size: 1.28571429rem;
  }

  p {
    margin: 0em 0em 10px;
    line-height: 1.5;
  }

  a {
    color: ${COLORS.primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
      &:not([type="button"]) {
        color: ${COLORS.primary};
      }
    }
  }

  ::-webkit-selection {
    background-color: #cce2ff;
  }

  ::selection {
    background-color: #cce2ff;
  }

  textarea::-webkit-selection,
  input::-webkit-selection {
    background-color: rgba(100, 100, 100, 0.4);
  }

  textarea::selection,
  input::selection {
    background-color: rgba(100, 100, 100, 0.4);
  }

  body ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
  }

  body ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 0px;
  }

  body ::-webkit-scrollbar-thumb {
    cursor: pointer;
    border-radius: 5px;
    background: rgba(0, 0, 0, 0.25);
    -webkit-transition: color ${VARS.animation.duration}
      ${VARS.animation.timing};
    transition: color ${VARS.animation.duration} ${VARS.animation.timing};
  }

  body ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(0, 0, 0, 0.15);
  }

  body ::-webkit-scrollbar-thumb:hover {
    background: rgba(128, 135, 139, 0.8);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 1.28571429em;
    margin: calc(2rem - 0.14285714em) 0em 1rem;
    font-weight: ${VARS.font.bold};
    padding: 0em;
  }

  h6 {
    font-size: 1.14285714rem;
  }
`;

export const base = css`
  html,
  body {
    margin: 0;
    padding: 0;
    height: auto;
    min-height: 100vh;
    font-family: ${VARS.base.fontFamily};
    font-weight: ${VARS.base.fontWeight};
    font-size: ${VARS.base.fontSize};
    color: ${COLORS.battleshipGrey};
    background-color: ${COLORS.whiteLilac};
  }

  #root {
    margin: 0;
    padding: 0;
    width: 100%;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
  }

  .hidden-visually,
  .visually-hidden,
  .hidden-input {
    border: 0 !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    margin: -1px !important;
    overflow: hidden !important;
    padding: 0 !important;
    position: absolute !important;
    width: 1px !important;
  }

  .grecaptcha-badge {
    visibility: hidden;
  }
`;
